import request from '@/utils/request'

// GET /api/base/qrySoftVersion 查询软件版本
export function fetchList(params) {
  return request({
    url: '/api/base/qryFeedBack',
    method: 'GET',
    params
  })
}
